import React from "react";
import { Chip } from "@mui/material";
import { getAttendanceStatusChipColor } from "utils/attendance";

const AttendanceStatusChip = ({ status, label, size = "small" }) => (
  <Chip
    label={label || status || "—"}
    size={size}
    color={getAttendanceStatusChipColor(status)}
    sx={{ fontWeight: 600 }}
  />
);

export default AttendanceStatusChip;
